<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="document._id ? deleteAction : false"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown()"
    >
        <div class="row align-items-center mb-2">
            <div class="col">
                <b-form-group :label="$t('Title')">
                    <b-form-input v-model="document.title" :placeholder="$t('Ex.: Agreement')"></b-form-input>
                </b-form-group>
            </div>

            <div class="col-2">
                <b-form-group :label="$t('Language')">
                    <b-form-select v-model="document.language" :options="languages"></b-form-select>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-9 col-md-12 col-12">
                <editor
                    :shortCuts="shortCuts"
                    v-model="document.content"
                    :editor-plugins="editorPlugins"
                    :editor-toolbar="editorToolbar"
                    :editor-menu="false"
                />
            </div>
            <div class="col-lg-3 col-md-12 col-12">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="table-responsive">
                            <table class="table table-hover table-sm">
                                <thead>
                                <tr>
                                    <th scope="col">{{$t('Title')}}</th>
                                    <th scope="col">{{$t('Value')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="shortcut in shortCuts">
                                    <td class="text-muted py-2">{{$t(shortcut.title)}}</td>
                                    <td class="py-2">{{shortcut.value}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Editor from '@/components/Editor.vue';
import {mapActions} from 'vuex';
import {modalMixins} from '@/mixins/modal.js'


export default {
    name: 'document-form-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        Editor,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            languages: [
                {text: 'English', value: 'english'},
                {text: 'Russian', value: 'russian'},
            ],
            document: {
                language: 'russian'
            },
            title: 'Document',
            shortCuts: [
                {title: 'Company', value: '#COMPANY_NAME'},
                {title: 'Patient first name', value: '#USER.FIRST_NAME'},
                {title: 'Patient last name', value: '#USER.LAST_NAME'},
                {title: 'Patient middle name', value: '#USER.MIDDLE_NAME'},
                {title: 'Patient age', value: '#USER.AGE'},
                {title: 'Patient birth date', value: '#USER.BIRTH_DATE'},
                {title: 'Patient gender', value: '#USER.GENDER'},
                {title: 'Patient address', value: '#USER.ADDRESS'},
                {title: 'Patient diagnosis', value: '#USER.DIAGNOSIS'},
                {title: 'Patient passport number', value: '#USER.PASSPORT_NUMBER'},
                {title: 'Patient passport given by', value: '#USER.PASSPORT_GIVEN'},
                {title: 'Doctor first name', value: '#DOCTOR.FIRST_NAME'},
                {title: 'Doctor last name', value: '#DOCTOR.LAST_NAME'},
                {title: 'Current date', value: '#CURRENT_DATE'},
            ],
            editorPlugins: ['table lists nonbreaking codesample table pagebreak lists code print'],
            editorToolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
                'alignleft aligncenter alignright alignjustify | outdent indent |  ' +
                'numlist bullist | table pagebreak | code | removeformat print'
        }
    },
    computed: {},
    mounted() {
        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({query: {}}).data;

    },
    methods: {
        ...mapActions('documents', ['find', 'create', 'patch', 'remove']),

        save() {
            let promise, successMessage;
            if (this.document._id) {
                promise = this.patch([this.document._id, this.document]);
                successMessage = this.$t('Complaint has been updated');
            } else {
                promise = this.create(this.document);
                successMessage = this.$t('Complaint has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {

            this.remove(this.document._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Document has been removed')
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.document = this.data;
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },


    },

}
</script>

<style lang="scss">

</style>
